export default __webpack_public_path__ + "static/media/addition-not-budget-icon.c79bda91.svg";